<template>
  <b-container class="mw-100 mt-3 mb-2">
    <b-card>
      <validation-observer v-slot="{ invalid }" ref="form">
        <b-container class="m-0 p-0 mw-100">
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <validation-provider :name="$tc('message.surname', 1).toLowerCase()"
                                   :rules="{ max: 50, required: true }"
                                   v-slot="{ changed, valid, errors }">
                <b-form-group>
                  <label slot="label" class="m-0 p-0">
                    {{$tc('message.surname', 1)}}
                  </label>

                  <b-input-group>
                    <b-form-input id="input-surname"
                                  v-model="input.surname"
                                  autocomplete="off"
                                  :placeholder="`${$tc('message.example', 1)}: Barberini`"
                                  :state="changed ? valid : null">
                    </b-form-input>
                  </b-input-group>

                  <div v-if="changed && !valid" class="my-invalid-feedback"> <h6>{{ first(errors) }}</h6></div>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <validation-provider :name="$tc('message.name', 1).toLowerCase()"
                                   :rules="{ max: 50, required: true }"
                                   v-slot="{ changed, valid, errors }">
                <b-form-group>
                  <label slot="label" class="m-0 p-0">{{$tc('message.name', 1)}}</label>

                  <b-input-group>
                    <b-form-input id="input-name"
                                  v-model="input.name"
                                  autocomplete="off"
                                  :placeholder="`${$tc('message.example', 1)}: Agata`"
                                  :state="changed ? valid : null">
                    </b-form-input>
                  </b-input-group>

                  <div v-if="changed && !valid" class="my-invalid-feedback"> <h6>{{ first(errors) }}</h6></div>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <validation-provider :name="$tc('message.taxCode', 1).toLowerCase()"
                                   :rules="{ taxCode: true, required: true }"
                                   v-slot="{ changed, valid, errors }">
                <b-form-group>
                  <label slot="label" class="m-0 p-0">{{$tc('message.taxCode', 1)}}</label>

                  <b-input-group>
                    <b-form-input id="input-taxCode"
                                  v-model="input.taxCode"
                                  autocomplete="off"
                                  :placeholder="`${$tc('message.example', 1)}: BRBGTA66D50H730V`"
                                  :state="changed ? valid : null">
                    </b-form-input>
                  </b-input-group>

                  <div v-if="changed && !valid" class="my-invalid-feedback"> <h6>{{ first(errors) }}</h6></div>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <b-form-group :label="`${$tc('message.drivingLicense', 1)}`"
                            label-for="input-driving-license">
                <model-list-select id="input-driving-license"
                                   option-text="text"
                                   option-value="value"
                                   :placeholder="drivingLicenseOptions && drivingLicenseOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                   v-model="input.licenseType"
                                   :list="drivingLicenseOptions">
                </model-list-select>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <validation-provider :name="$tc('message.email', 1).toLowerCase()"
                                   :rules="{ max: 100, email: true }"
                                   v-slot="{ changed, valid, errors }">
                <b-form-group :label="`${$tc('message.email', 1)}`"
                              label-for="input-other-mail-address">
                  <b-form-input id="input-other-mail-address"
                                v-model="input.email"
                                autocomplete="off" type="text"
                                :placeholder="`${$tc('message.example', 1)}: prova@gmail.com`"
                                :state="changed ? valid : null">
                  </b-form-input>

                  <div
                      v-if="changed && !valid"
                      class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <validation-provider :name="$tc('message.telephoneNumber', 1).toLowerCase()"
                                   :rules="{ min: 9, max: 30 }"
                                   v-slot="{ changed, valid, errors }">
                <b-form-group :label="$tc('message.telephoneNumber', 1)"
                              label-for="input-number">
                  <b-form-input id="input-number"
                                v-model="input.cell"
                                autocomplete="off"
                                :placeholder="`${$tc('message.example', 1)}: 33322558899`"
                                :state="changed ? valid : null">
                  </b-form-input>

                  <div v-if="changed && !valid" class="my-invalid-feedback"> <h6>{{ first(errors) }}</h6></div>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <b-form-group :label="$t('message.consensus')"
                            label-for="input-consensus">
                <b-form-checkbox
                    id="input-consensus"
                    class="mt-2"
                    v-model="input.consensus">
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <b-form-group :label="$t('message.exemption')"
                            label-for="input-exemption">
                <b-form-checkbox
                    id="input-exemption"
                    class="mt-2"
                    v-model="input.exemption">
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="border-bottom border-c-green mb-3">
            <b-col>
              <label class="c-green ml-1">
                {{$tc('message.contractData', 1)}}
              </label>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <b-form-group :label="`${$tc('message.society', 1)}`"
                            label-for="input-company">
                <model-list-select id="input-company"
                                   option-text="text"
                                   option-value="value"
                                   :placeholder="companyOptions && companyOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                   v-model="input.company"
                                   :list="companyOptions">
                </model-list-select>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <validation-provider :name="$tc('message.badgeNumber', 1).toLowerCase()"
                                   :rules="{ max: 25 }"
                                   v-slot="{ changed, valid, errors }">
                <b-form-group>
                  <label slot="label" class="m-0 p-0">{{$tc('message.badgeNumber', 1)}}</label>

                  <b-input-group>
                    <b-form-input id="input-badgeNumber"
                                  v-model="input.badgeNumber"
                                  autocomplete="off"
                                  :placeholder="`${$tc('message.example', 1)}: ak715tpr2`"
                                  :state="!valid ? valid : null">
                    </b-form-input>
                  </b-input-group>

                  <div v-if="changed && !valid" class="my-invalid-feedback"> <h6>{{ first(errors) }}</h6></div>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <b-form-group :label="`${$tc('message.date', 1)} ${$tc('message.start', 1).toLowerCase()} ${$tc('message.contract', 1).toLowerCase()}`"
                            label-for="input-start">
                <b-input-group>
                  <flat-pickr id="input-start"
                              :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                              class="form-control"
                              :readonly="false"
                              v-model="input.startContract"
                              :config="startDateConfig"
                              @on-change="startDateChange">
                  </flat-pickr>
                  <div class="input-group-append">
                    <b-button @click="input.startContract = null"
                              :disabled="!input.startContract">
                      <font-awesome-icon icon="trash"/>
                    </b-button>
                  </div>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <b-form-group :label="`${$tc('message.date', 1)} ${$tc('message.end', 1).toLowerCase()} ${$tc('message.contract', 1).toLowerCase()}`"
                            label-for="input-end">
                <b-input-group>
                  <flat-pickr id="input-end"
                              :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                              class="form-control"
                              :readonly="false"
                              v-model="input.endContract"
                              :config="endDateConfig"
                              @on-change="endDateChange">
                  </flat-pickr>
                  <div class="input-group-append">
                    <b-button @click="input.endContract = null"
                              :disabled="!input.endContract">
                      <font-awesome-icon icon="trash"/>
                    </b-button>
                  </div>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <validation-provider :name="$tc('message.keyCode', 1).toLowerCase()"
                                   :rules="{ max: 50 }"
                                   v-slot="{ changed, valid, errors }">
                <b-form-group>
                  <label slot="label" class="m-0 p-0">{{$tc('message.keyCode', 1)}}</label>

                  <b-input-group>
                    <b-form-input id="input-keyCode"
                                  v-model="input.keyCode"
                                  autocomplete="off"
                                  :placeholder="`${$tc('message.example', 1)}: 684654684964`">
                    </b-form-input>
                  </b-input-group>

                  <div v-if="changed && !valid" class="my-invalid-feedback"> <h6>{{ first(errors) }}</h6></div>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <!-- EMPTY COL -->
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3" class="text-center">
              <b-form-group :label="$tc('message.resigned', 1)"
                            label-for="input-executed" >
                <switch-button v-model="resigned"
                               :color="{checked: '#249a80', unchecked: '#dc3545'}"
                               :sync="true"
                               :width="100"
                               :height="32"
                               :font-size="15.5"
                               :speed="500"
                               :labels="true"
                               @change="resignedChanged">
                  <template slot="checked">
                    {{$t('message.yes')}}
                  </template>
                  <template slot="unchecked">
                    {{$t('message.no')}}
                  </template>
                </switch-button>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <transition name="scroll-fade">
                <b-form-group v-show="resigned">
                  <label slot="label" class="m-0 p-0">
                    {{$tc('message.date', 1)}} {{$tc('message.resign', 1).toLowerCase()}} {{$tc('message.contract', 1).toLowerCase()}}
                  </label>
                  <b-input-group>
                    <flat-pickr id="input-resigned"
                                :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                class="form-control"
                                v-model="input.resignDate"
                                :config="resignDateConfig">
                    </flat-pickr>
                    <div class="input-group-append">
                      <b-button @click="input.resignDate = null"
                                :disabled="!input.resignDate">
                        <font-awesome-icon icon="trash"/>
                      </b-button>
                    </div>
                  </b-input-group>
                </b-form-group>
              </transition>
            </b-col>
          </b-row>

          <b-row class="mt-0">
            <b-col class="mt-3 justify-content-end d-flex">
              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-green mr-2" v-on:click="checkStaff(false)"
                        id="save-staff"
                        v-if="driverId ? config.u : config.c"
                        :disabled="invalid || !itemChanged">{{$t('message.save')}}
              </b-button>

              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-green mr-2" v-on:click="checkStaff(true)"
                        id="save-close-staff"
                        v-if="driverId ? config.u : config.c"
                        :disabled="invalid || !itemChanged">{{$t('message.saveClose')}}
              </b-button>

              <b-button class="b-c-green" v-on:click="pushBack()"
                        id="close-staff">{{$t('message.close')}}</b-button>
            </b-col>
          </b-row>
        </b-container>
      </validation-observer>
    </b-card>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { first, cloneDeep, find } from 'lodash'
import { DateTime } from 'luxon'
import { Italian } from 'flatpickr/dist/l10n/it.js'
import logKeys from "@/plugins/log-keys";

export default {
  name: 'EditStaff',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      this.$nextTick(() => {
        if (this && this.$refs && this.$refs.form) this.$refs.form.validate()
      })
      if (this.$el.isConnected) {
        this.getOptions()
        this.updateLinks()
      }
    })
  },
  data () {
    const driverId = this.$route.params.id !== 'new' ? this.$route.params.id : null
    const genericDateConfig = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      minDate: '',
      maxDate: '',
      disable: []
    }
    const config = this.$route.meta.config

    return {
      config,
      first,
      driverId,
      DateTime,
      startDateConfig: cloneDeep(genericDateConfig),
      endDateConfig: cloneDeep(genericDateConfig),
      resignDateConfig: cloneDeep(genericDateConfig),
      input: { company: null, licenseType: null },
      drivingLicenseOptions: [],
      companyOptions: [],
      drivingLicenseFilter: null,
      companyFilter: null,
      itemChanged: false,
      watcher: null,
      resigned: false,
      links: [
        '/configuration/company',
        '/configuration/driving_license'
      ],
      duplicateTaxCode: false
    }
  },
  watch: {
    'input.taxCode' () {
      if (this.duplicateTaxCode) this.duplicateTaxCode = false
    }
  },
  methods: {
    clickedLink (link) {
      this.pushBack(link.href)
    },
    checkWatcher () {
      this.$root.$emit('activeLoader', true)
      if (this.watcher) this.watcher()
      this.itemChanged = false
    },
    addWatcher () {
      this.$root.$emit('activeLoader', false)
      this.watcher = this.$watch('input', () => {
        this.itemChanged = true
      }, { deep: true })
    },
    fetchData () {
      this.checkWatcher()
      this.getOptions().then(() => {
        this.getDriver()
      })
    },
    getOptions () {
      const axiosArray = []
      axiosArray.push(this.getEnum('driving_license', 'drivingLicenseOptions', true))
      axiosArray.push(this.getEnum('company', 'companyOptions', true))
      this.updateLinks()
      return Vue.myAll(axiosArray).then(r => r).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getEnum (path, obj, selectionMessage) {
      const options = []

      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        if (selectionMessage) {
          options.push({ value: '', text: items.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') })
        }
        items.forEach((item) => {
          options.push({ value: item.id, text: item.descr })
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getDriver () {
      if (this.driverId) {
        return Vue.myGet(this, `/drivers/${this.driverId}`, 'drivers').then((drivers) => {
          const driver = first(drivers)
          this.input = driver
          this.resigned = !!driver.resignDate
          this.$root.$emit('activeLoader', false)
          this.addWatcher()
          return driver
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
          return false
        })
      } else {
        this.input = { company: null, licenseType: null }
        this.resigned = false
        this.$root.$emit('activeLoader', false)
        this.addWatcher()
        return this.input
      }
    },
    checkSaveButton () {
      const data = this.input
      return !data.surname || !data.name || !data.taxCode || data.taxCode.length !== 16 || !this.itemChanged || this.duplicateTaxCode
    },
    pushBack (obj) {
      const backObj = obj || { name: 'Staff' }
      if (this.itemChanged) this.$root.$emit('go-back-modal', backObj)
      else this.$router.push(backObj)
    },
    checkStaff (pushBack) {
      const driver = this.normalizeInputs()
      const alreadyInDataBase = this.driverId
      if (!alreadyInDataBase) return this.checkDuplicatedTaxCode(driver, pushBack)
      return this.saveStaff(driver, pushBack)
    },
    checkDuplicatedTaxCode (driver, pushBack) {
      return Vue.myGet(this, '/drivers', 'drivers').then((drivers) => {
        const taxCodeAlreadyExist = find(drivers, obj => obj.taxCode === driver.taxCode)
        if (taxCodeAlreadyExist) {
          this.duplicateTaxCode = true
        }
        return taxCodeAlreadyExist ? false : this.saveStaff(driver, pushBack)
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return error
      })
    },
    saveStaff (driver, pushBack) {
      if (driver.customerId) delete driver.customerId
      if (driver.id) delete driver.id
      const dataId = this.driverId ? this.driverId : false

      return Vue.putOrPost(this, !!this.driverId, `/drivers${dataId ? '/' + dataId : ''}`, driver, false).then((r) => {
        this.logData(dataId || r.data.id, !!this.driverId)

        Vue.success(this, `${this.$tc('message.staff', 1)} ${this.$t(dataId ? 'success.putSuccess' : 'success.postSuccess')}`)
        if (pushBack) {
          this.itemChanged = false
          this.pushBack()
        } else {
          this.$router.push({ name: 'RefreshPage', params: { id: dataId || r.data.id, name: 'EditStaff' } })
        }
        return true
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return error
      })
    },
    normalizeInputs () {
      const data = cloneDeep(this.input)
      if (!data.keyCode) data.keyCode = null
      if (!data.badgeNumber) data.badgeNumber = null
      if (!data.company) data.company = null
      if (!data.startContract || data.startContract === '') data.startContract = null
      if (!data.endContract || data.endContract === '') data.endContract = null
      if (!data.resignDate || data.resignDate === '') data.resignDate = null
      if (!data.licenseType) data.licenseType = null
      data.taxCode = data.taxCode.toUpperCase()
      return data
    },
    updateLinks () {
      const links = []
      this.links.forEach(link => {
        links.push({ href: link })
      })
      this.$root.$emit('change-links', links)
    },
    checkData (first) {
      const changed = this.itemChanged
      if (first) {
        return { class: 'form-control is-valid', state: true }
      } else if (changed) {
        return { class: 'form-control is-invalid', state: false }
      }
      return { class: 'form-control', state: null }
    },
    startDateChange (val) {
      this.updateDateConfig(val, this.input.endContract)
    },
    endDateChange (val) {
      this.updateDateConfig(this.input.startContract, val)
    },
    updateDateConfig (start, end) {
      let editedStart = start
      let editedEnd = end
      if (start && start[0] && DateTime.fromJSDate(start[0]).isValid) {
        editedStart = DateTime.fromJSDate(start[0]).toSQLDate()
      } else if (start && start[0] && DateTime.fromHTTP(start[0]).isValid) {
        editedStart = DateTime.fromHTTP(start[0]).toSQLDate()
      }
      if (end && end[0] && DateTime.fromJSDate(end[0]).isValid) {
        editedEnd = DateTime.fromJSDate(end[0]).toSQLDate()
      } else if (end && end[0] && DateTime.fromHTTP(end[0]).isValid) {
        editedEnd = DateTime.fromHTTP(end[0]).toSQLDate()
      }

      this.startDateConfig.maxDate = editedEnd ? DateTime.fromSQL(editedEnd).toSQLDate() : null
      this.endDateConfig.minDate = editedStart ? DateTime.fromSQL(editedStart).toSQLDate() : null
      this.resignDateConfig.minDate = editedStart ? DateTime.fromSQL(editedStart).toSQLDate() : null
      this.resignDateConfig.maxDate = editedEnd ? DateTime.fromSQL(editedEnd).toSQLDate() : null
    },
    resignedChanged (event) {
      if (!event.value) this.input.resignDate = null
    },
    logData (driverId, put) {
      const logObj = Vue.getLogObj(this, put ? 'put' : 'post', '/organization/registry_staff/:id')

      logObj.data.details = []

      if (driverId) logObj.data.details.push({text: 'message.driver', option: 1, value: driverId, key: logKeys.driver})

      Vue.myLogPost(logObj)
    }
  }
}
</script>

<style scoped>

</style>
